export default class AcceptTOS {
  constructor () {
    const tosCheckbox = document.getElementById('ToS')
    if (tosCheckbox) {
      // Call the method once on load to set the style
      // according to the checkbox state
      this.showState()

      // And also call it when the checkbox is clicked
      tosCheckbox.addEventListener('click', this.showState)

      for (const element of document.getElementsByClassName('tos-walled')) {
        element.addEventListener('click', this.checkProceed)
      }
    }
  }

  checkProceed(ev) {
    const checkBox = document.getElementById('ToS')
    if (checkBox.checked == false) {
      ev.preventDefault()
      window.alert('You have to accept the Terms of Service to use the software.')
      window.open('../terms-of-service/')
    }
  }

  showState() {
    const checkBox = document.getElementById('ToS')
    for (const element of document.getElementsByClassName('tos-walled')) {
      element.style.opacity = checkBox.checked ? 1 : 0.5
    }
  }
}
